const KayanURL = "https://om.kayan-healthcare.com";

let settings = {
  KayanURL,
};
export default settings;
